import cn from 'classnames';
import React, { ChangeEvent, CSSProperties, ReactNode } from 'react';

import { RadioVariant } from '../RadioGroup.types';

import styles from './Radio.module.scss';

export type RadioProps = {
  children: ReactNode;
  variant?: RadioVariant;
  value?: string | number;
  name?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  checked?: boolean;
  className?: string;
  testID?: string;
  style?: CSSProperties;
  disabled?: boolean;
  error?: boolean;
  id?: string;
};

const InternalRadio: React.ForwardRefRenderFunction<
  HTMLInputElement,
  RadioProps
> = (props, ref) => {
  const {
    children,
    variant = 'default',
    value,
    name,
    onChange,
    checked,
    className,
    testID,
    style,
    disabled,
    error,
    id,
    ...restBaseInputProps
  } = props;

  return (
    <label
      id={id}
      style={style}
      className={cn(
        styles.container,
        variant === 'default' && styles.variantDefault,
        variant === 'tab' && styles.variantTab,
        disabled && styles.disabled,
        error && styles.isError,
        'p2',
        className,
      )}
      data-testid={testID}
    >
      <input
        {...restBaseInputProps}
        ref={ref}
        value={value}
        type="radio"
        checked={checked}
        onChange={onChange}
        className={styles.input}
        disabled={disabled}
        name={name}
      />
      {variant === 'default' && (
        <>
          <span className={styles.defaultRadio} />
          {children !== undefined ? (
            <span className={styles.label}>{children}</span>
          ) : null}
        </>
      )}

      {variant === 'tab' && <span className={styles.tabRadio}>{children}</span>}
    </label>
  );
};

export const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  InternalRadio,
);
